import type { Category, CommentKind, TopicLevel, Verdict } from "@sikilesi/protocol";

/** Every upper-case word in the UI goes through this: Turkish casing (i → İ, ı → I). Never CSS text-transform. */
export const up = (s: string): string => s.toLocaleUpperCase("tr-TR");

/** The stamp word, always with dotted capital İ. */
export const SIKILESI = up("sikilesi");
/** The stamp word on tam.sikile.si: one word, dotted İ. */
export const TAMSIKILESI = up("tamsikilesi");

export const LEVEL_ORDER: readonly TopicLevel[] = ["hafif", "sikilasi", "sikilesi", "tam"];

export { LEVEL_WORDS, levelLabel } from "@sikilesi/protocol/constants";
export { formatEventYear } from "@sikilesi/protocol/realm";

export const CATEGORY_WORDS: Readonly<Record<Category, string>> = {
  uzay: "uzay",
  okyanus: "okyanus",
  internet: "internet",
  burokrasi: "bürokrasi",
  tuketim: "tüketim",
  diger: "diğer",
};

export const KIND_WORDS: Readonly<Record<CommentKind, string>> = {
  itiraz: "itiraz",
  katiliyorum: "katılıyorum",
  ek_kanit: "ek kanıt",
};

export const VERDICT_WORDS: Readonly<Record<Verdict, string>> = {
  "sikile.si": "sikile.si",
  "tam.sikile.si": "tam.sikile.si",
};

/** gundem clipping: "2026-11-05" → "OLAY: 5 KASIM". */
export const eventDateLabel = (isoDate: string): string => {
  const d = new Date(`${isoDate}T12:00:00Z`);
  if (Number.isNaN(d.getTime())) return "";
  return up(`olay: ${d.toLocaleDateString("tr-TR", { day: "numeric", month: "long", timeZone: "UTC" })}`);
};

/** "www.nasa.gov" → "NASA.GOV" */
export const evidenceLabel = (domain: string): string => up(`kanıt: ${domain.replace(/^www\./i, "")}`);
